import React from 'react';
import { Grid, Button, Dropdown, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';

const AssignUserVM = ({
  onChangeOfVMCohort,
  onChangeOfUser,
  userLoading,
  vmCohortLoading,
  submitting,
  handleSubmit,
  vmCohortList,
  userList
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title> Assign Vending Machine Cohort to User </title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Assign Vending Machine Cohort to User
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Select User</label>
            <Dropdown
              disabled={userLoading || submitting}
              onChange={onChangeOfUser}
              selection
              multiple
              search
              options={userList || []}
            />
          </Form.Field>
          <Form.Field>
            <label>Select Cohort</label>
            <Dropdown
              disabled={vmCohortLoading || submitting}
              onChange={onChangeOfVMCohort}
              selection
              multiple
              options={vmCohortList}
            />
          </Form.Field>
          <Form.Field />
          <Button
            loading={submitting}
            onClick={handleSubmit}
            basic
            color="blue"
            style={{ float: 'right' }}
          >
            Assign VM(s)
          </Button>
        </Form>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default AssignUserVM;



// WEBPACK FOOTER //
// ./src/Modules/UsersAssignVM/component.jsx